import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import BaseVariant from './BaseVariant';

const style = theme => ({
	root: {
		
	},
})

function RangeVariant({
	index,
	formikProps,
	isLast,
	disabled
}) {

	return (
		<BaseVariant
			index={index}
			formikProps={formikProps}
			isLast={isLast}
			disabled={disabled}
		/>
	)
}

RangeVariant.propTypes = {
	classes: PropTypes.any,
}

RangeVariant.defaultProps = {
}

export default withStyles(style)(RangeVariant);